export function msform() {
  
  $(".msform .choices.size .choice").click(function() {
    
    $(".msform .choices.size .choice").removeClass('active');
    $(this).addClass('active');
    $(".msform .choices.size").find("input[name="+$(this).parent().data('step')+"]").val($(this).data('value'));
    $(".msform").find("input[name=size]").val($(this).data('value'));
  });

  $(".msform .next").click(function(e) {
    e.preventDefault();
    
    $('.msform .required').removeClass('invalid');
    
    var errors = 0;
    var cur_fs = $(this).closest("fieldset");
    
    cur_fs.find('.required').each(function(i, v) {
      
      if($(v).hasClass('choices')) {
        if($(v).find(':checkbox:checked').length == 0) {
          errors++;
          $(v).addClass('invalid');
        }
      }
      else {
        if(!$(v).val()) {
          errors++;
          $(v).addClass('invalid');
          
          if($(v).parent().hasClass('become-an-author-lesson-content'))
            $(v).parent().removeClass('minimised');
          
        }
        else {
          if($(v).hasClass('email')) {
            if(!/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test($(v).val())) {
              errors++;
              $(v).addClass('invalid');
            }
          }
        }
      }
    });
    
    if(errors > 0)
      return;
    
    var next_fs = cur_fs.next("fieldset");
    var bar = $('#progressbar .bar-inner');
    
    cur_fs.fadeOut(function() {
      next_fs.fadeIn();
      if((cur_fs).data('step') == '1')
        bar.addClass('step2');
      else if((cur_fs).data('step') == '2')
        bar.addClass('step3');
    });
    
  });

  $(".msform .previous").click(function(e) {
    e.preventDefault();
    
    var cur_fs = $(this).closest("fieldset");
    var prev_fs = cur_fs.prev();
    var bar = $('#progressbar .bar-inner');
    
    cur_fs.fadeOut(function() {
      prev_fs.fadeIn();
      if((cur_fs).data('step') == '3')
        bar.removeClass('step3').addClass('step2');
      else if((cur_fs).data('step') == '2')
        bar.removeClass('step2').addClass('step1');
    });
    
  });

  $(".msform .send-for-review").click(function(e) {
    
    e.preventDefault();
    
    $('.msform .required').removeClass('invalid');
    
    var errors = 0;
    var cur_fs = $(this).closest("fieldset");
    
    cur_fs.find('.required').each(function(i, v) {
      
      if($(v).hasClass('choices')) {
        if($(v).find(':checkbox:checked').length == 0) {
          errors++;
          $(v).addClass('invalid');
        }
      }
      else {
        if(!$(v).val()) {
          errors++;
          $(v).addClass('invalid');
          
          if($(v).parent().hasClass('become-an-author-lesson-content'))
            $(v).parent().removeClass('minimised');
          
        }
        else {
          if($(v).hasClass('email')) {
            if(!/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test($(v).val())) {
              errors++;
              $(v).addClass('invalid');
            }
          }
        }
      }
    });
    
    if(errors > 0)
      return;
    
    $(this).closest('form').submit();
    
  })


  $('body').on('click', '.add-lesson', function(e) {
    
    e.preventDefault();
    
    var lessonContainer = $('.become-an-author-lesson-container');
    
    var lessonToggler = '<svg height="20" width="20" viewBox="0 -1 401.52289 401" xmlns="http://www.w3.org/2000/svg"><path d="m370.589844 250.972656c-5.523438 0-10 4.476563-10 10v88.789063c-.019532 16.5625-13.4375 29.984375-30 30h-280.589844c-16.5625-.015625-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980469 30-30h88.789062c5.523438 0 10-4.476563 10-10 0-5.519531-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398437-50 50v260.59375c.03125 27.601563 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398437 50-50v-88.792969c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m376.628906 13.441406c-17.574218-17.574218-46.066406-17.574218-63.640625 0l-178.40625 178.40625c-1.222656 1.222656-2.105469 2.738282-2.566406 4.402344l-23.460937 84.699219c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.699219-23.464843c1.664062-.460938 3.179687-1.34375 4.402344-2.566407l178.402343-178.410156c17.546875-17.585937 17.546875-46.054687 0-63.640625zm-220.257812 184.90625 146.011718-146.015625 47.089844 47.089844-146.015625 146.015625zm-9.40625 18.875 37.621094 37.625-52.039063 14.417969zm227.257812-142.546875-10.605468 10.605469-47.09375-47.09375 10.609374-10.605469c9.761719-9.761719 25.589844-9.761719 35.351563 0l11.738281 11.734375c9.746094 9.773438 9.746094 25.589844 0 35.359375zm0 0"/></svg>';
    
    var deleteLesson = '<svg height="20" width="20" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><path d="M425.298,51.358h-91.455V16.696c0-9.22-7.475-16.696-16.696-16.696H194.855c-9.22,0-16.696,7.475-16.696,16.696v34.662H86.704c-9.22,0-16.696,7.475-16.696,16.696v51.357c0,9.22,7.475,16.696,16.696,16.696h5.072l15.26,359.906c0.378,8.937,7.735,15.988,16.68,15.988h264.568c8.946,0,16.302-7.051,16.68-15.989l15.259-359.906h5.073c9.22,0,16.696-7.475,16.696-16.696V68.054C441.994,58.832,434.519,51.358,425.298,51.358z M211.551,33.391h88.9v17.967h-88.9V33.391z M372.283,478.609H139.719l-14.522-342.502h261.606L372.283,478.609z M408.602,102.715c-15.17,0-296.114,0-305.202,0V84.749h305.202V102.715z"/><path d="M188.835,187.304c-9.22,0-16.696,7.475-16.696,16.696v206.714c0,9.22,7.475,16.696,16.696,16.696c9.22,0,16.696-7.475,16.696-16.696V204C205.53,194.779,198.055,187.304,188.835,187.304z"/><path d="M255.998,187.304c-9.22,0-16.696,7.475-16.696,16.696v206.714c0,9.22,7.474,16.696,16.696,16.696c9.22,0,16.696-7.475,16.696-16.696V204C272.693,194.779,265.218,187.304,255.998,187.304z"/><path d="M323.161,187.304c-9.22,0-16.696,7.475-16.696,16.696v206.714c0,9.22,7.475,16.696,16.696,16.696s16.696-7.475,16.696-16.696V204C339.857,194.779,332.382,187.304,323.161,187.304z"/></svg>';
    
    lessonContainer.find('.become-an-author-lesson-content').addClass('minimised');
    
    var newLessonIndex = lessonContainer.find('.become-an-author-lesson').length + 1;
    
    var newLessonHTML = '<div class="become-an-author-lesson">';
    newLessonHTML +=      '<div class="become-an-author-lesson-header">';
    newLessonHTML +=        '<h6>Lesson ' + newLessonIndex + '</h6><div class="become-an-author-lesson-header-action"><a href="#" class="become-an-author-lesson-toggler" data-id="' + newLessonIndex + '">' + lessonToggler + '</a><a href="#" class="become-an-author-lesson-remove" data-id="' + newLessonIndex + '">' + deleteLesson + '</a></div>';
    newLessonHTML +=      '</div>';
    newLessonHTML +=      '<div class="become-an-author-lesson-content">';
    newLessonHTML +=        '<input type="text" class="big required" id="lesson-' + newLessonIndex + '-title" name="lesson-' + newLessonIndex + '-title" required placeholder="Lesson title" required />';
    newLessonHTML +=        '<textarea rows="10" class="required" id="lesson-' + newLessonIndex + '-description" name="lesson-' + newLessonIndex + '-description" required placeholder="Lesson description" required></textarea>';
    newLessonHTML +=        '<input type="text" class="big required" id="lesson-' + newLessonIndex + '-video" name="lesson-' + newLessonIndex + '-video" required placeholder="Lesson video link" required />';
    newLessonHTML +=        '<label for="lesson-' + newLessonIndex + '-assets">Lesson assets (archive): </label>';
    newLessonHTML +=        '<input type="file" accept="zip,application/zip" id="lesson-' + newLessonIndex + '-assets" name="lesson-' + newLessonIndex + '-assets" multiple="false" />';
    newLessonHTML +=      '</div>';
    newLessonHTML +=    '</div>';
    
    lessonContainer.append(newLessonHTML);
    
    $('#course_mastercourse_lesson_quantity').val(parseInt($('#course_mastercourse_lesson_quantity').val()) + 1);
    
  });
  
  $('body').on('click', '.add-project', function(e) {
    
    e.preventDefault();
    
    var lessonContainer = $('.become-an-author-lesson-container');
    
    var lessonToggler = '<svg height="20" width="20" viewBox="0 -1 401.52289 401" xmlns="http://www.w3.org/2000/svg"><path d="m370.589844 250.972656c-5.523438 0-10 4.476563-10 10v88.789063c-.019532 16.5625-13.4375 29.984375-30 30h-280.589844c-16.5625-.015625-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980469 30-30h88.789062c5.523438 0 10-4.476563 10-10 0-5.519531-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398437-50 50v260.59375c.03125 27.601563 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398437 50-50v-88.792969c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m376.628906 13.441406c-17.574218-17.574218-46.066406-17.574218-63.640625 0l-178.40625 178.40625c-1.222656 1.222656-2.105469 2.738282-2.566406 4.402344l-23.460937 84.699219c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.699219-23.464843c1.664062-.460938 3.179687-1.34375 4.402344-2.566407l178.402343-178.410156c17.546875-17.585937 17.546875-46.054687 0-63.640625zm-220.257812 184.90625 146.011718-146.015625 47.089844 47.089844-146.015625 146.015625zm-9.40625 18.875 37.621094 37.625-52.039063 14.417969zm227.257812-142.546875-10.605468 10.605469-47.09375-47.09375 10.609374-10.605469c9.761719-9.761719 25.589844-9.761719 35.351563 0l11.738281 11.734375c9.746094 9.773438 9.746094 25.589844 0 35.359375zm0 0"/></svg>';
    
    var deleteLesson = '<svg height="20" width="20" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><path d="M425.298,51.358h-91.455V16.696c0-9.22-7.475-16.696-16.696-16.696H194.855c-9.22,0-16.696,7.475-16.696,16.696v34.662H86.704c-9.22,0-16.696,7.475-16.696,16.696v51.357c0,9.22,7.475,16.696,16.696,16.696h5.072l15.26,359.906c0.378,8.937,7.735,15.988,16.68,15.988h264.568c8.946,0,16.302-7.051,16.68-15.989l15.259-359.906h5.073c9.22,0,16.696-7.475,16.696-16.696V68.054C441.994,58.832,434.519,51.358,425.298,51.358z M211.551,33.391h88.9v17.967h-88.9V33.391z M372.283,478.609H139.719l-14.522-342.502h261.606L372.283,478.609z M408.602,102.715c-15.17,0-296.114,0-305.202,0V84.749h305.202V102.715z"/><path d="M188.835,187.304c-9.22,0-16.696,7.475-16.696,16.696v206.714c0,9.22,7.475,16.696,16.696,16.696c9.22,0,16.696-7.475,16.696-16.696V204C205.53,194.779,198.055,187.304,188.835,187.304z"/><path d="M255.998,187.304c-9.22,0-16.696,7.475-16.696,16.696v206.714c0,9.22,7.474,16.696,16.696,16.696c9.22,0,16.696-7.475,16.696-16.696V204C272.693,194.779,265.218,187.304,255.998,187.304z"/><path d="M323.161,187.304c-9.22,0-16.696,7.475-16.696,16.696v206.714c0,9.22,7.475,16.696,16.696,16.696s16.696-7.475,16.696-16.696V204C339.857,194.779,332.382,187.304,323.161,187.304z"/></svg>';
    
    lessonContainer.find('.become-an-author-lesson-content').addClass('minimised');
    
    var newLessonIndex = lessonContainer.find('.become-an-author-lesson').length + 1;
    
    var newLessonHTML = '<div class="become-an-author-lesson">';
    newLessonHTML +=      '<div class="become-an-author-lesson-header">';
    newLessonHTML +=        '<h6>Project ' + newLessonIndex + '</h6><div class="become-an-author-lesson-header-action"><a href="#" class="become-an-author-lesson-toggler" data-id="' + newLessonIndex + '">' + lessonToggler + '</a><a href="#" class="become-an-author-lesson-remove" data-id="' + newLessonIndex + '">' + deleteLesson + '</a></div>';
    newLessonHTML +=      '</div>';
    newLessonHTML +=      '<div class="become-an-author-lesson-content">';
    newLessonHTML +=        '<input type="text" class="big required" id="project-' + newLessonIndex + '-title" name="project-' + newLessonIndex + '-title" required placeholder="Project title" required />';
    newLessonHTML +=        '<textarea rows="10" class="required" id="project-' + newLessonIndex + '-description" name="project-' + newLessonIndex + '-description" required placeholder="Project description" required></textarea>';
    newLessonHTML +=        '<label for="project-' + newLessonIndex + '-image">Project image/animation: </label><input type="file" class="required" id="project-' + newLessonIndex + '-image" name="project-' + newLessonIndex + '-image" accept="image/*" required multiple="false" />';
    newLessonHTML +=        '<input type="text" class="big required" id="project-' + newLessonIndex + '-video" name="project-' + newLessonIndex + '-video" required placeholder="Project video link" required />';
    newLessonHTML +=        '<label for="project-' + newLessonIndex + '-assets">Project assets (archive): </label>';
    newLessonHTML +=        '<input type="file" accept="zip,application/zip" id="project-' + newLessonIndex + '-assets" name="project-' + newLessonIndex + '-assets" multiple="false" />';
    newLessonHTML +=      '</div>';
    newLessonHTML +=    '</div>';
    
    lessonContainer.append(newLessonHTML);
    
    $('#course_mastercourse_lesson_quantity').val(parseInt($('#course_mastercourse_lesson_quantity').val()) + 1);
    
  });
  
  $('body').on('click', '.become-an-author-lesson-toggler', function(e) {
    
    e.preventDefault();
    
    $(this).parent().parent().find('+ .become-an-author-lesson-content').toggleClass('minimised');
    
  });
  
  $('body').on('click', '.become-an-author-lesson-remove', function(e) {
    
    e.preventDefault();
    
    $(this).closest('.become-an-author-lesson').remove();
    
    $('#course_mastercourse_lesson_quantity').val(parseInt($('#course_mastercourse_lesson_quantity').val())  - 1);
    
  });
  
  $('body').on('change', '#course_mastercourse_image', function(e) {
    
    $(this).find('~ .warning').remove();
    
    var mimeType = this.files[0]['type'];
    var fileSize = this.files[0].size;
    
    if(fileSize > 10000000) {
      $(this).after('<p class="warning" style="color: #e03a3a;">Allowed file size exceeded. (Max. 10 MB)</p>');
      this.value = null;
    }
    
    if(mimeType.split('/')[0] !== 'image') {
      $(this).after('<p class="warning" style="color: #e03a3a;">The selected file is not an image.</p>');
      this.value = null;
    }
    
  });
  
  $('body').on('change', '.become-an-author-lesson-content [id$="-image"]', function(e) {
    
    $(this).find('~ .warning').remove();
    
    var mimeType = this.files[0]['type'];
    var fileSize = this.files[0].size;
    
    if(fileSize > 10000000) {
      $(this).after('<p class="warning" style="color: #e03a3a;">Allowed file size exceeded. (Max. 10 MB)</p>');
      this.value = null;
    }
    
    if(mimeType.split('/')[0] !== 'image') {
      $(this).after('<p class="warning" style="color: #e03a3a;">The selected file is not an image.</p>');
      this.value = null;
    }
    
  });
  
  $('body').on('change', '.become-an-author-lesson-content [id$="-assets"]', function(e) {
    
    $(this).find('~ .warning').remove();
    
    var mimeType = this.files[0]['type'];
    var fileSize = this.files[0].size;
    
    var fileExtensions = ['application/zip', 'application/octet-stream', 'application/x-zip-compressed', 'multipart/x-zip', 'application/x-rar-compressed', 'application/octet-stream'];
    
    if(fileSize > 100000000) {
      $(this).after('<p class="warning" style="color: #e03a3a;">Allowed file size exceeded. (Max. 100 MB)</p>');
      this.value = null;
    }
    
    if($.inArray(mimeType, fileExtensions) == -1) {
      $(this).after('<p class="warning" style="color: #e03a3a;">The file is not an archive.</p>');
      this.value = null;
    }
    
  });
  
  
}


// WEBPACK FOOTER //
// ./assets/js/modules/msform.js